import React from 'react'
import PropTypes from 'prop-types'
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
import InputAdornment from '@material-ui/core/InputAdornment'
import Icon from '@material-ui/core/Icon'

// @material-ui/icons
import Face from '@material-ui/icons/Face'
// import Email from '@material-ui/icons/Email'
// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import GridContainer from 'components/Grid/GridContainer'
import GridItem from 'components/Grid/GridItem.jsx'
import CustomInput from 'components/CustomInput/CustomInput.jsx'
import Button from 'components/CustomButtons/Button.jsx'
import Card from 'components/Card/Card.jsx'
import CardBody from 'components/Card/CardBody.jsx'
import CardHeader from 'components/Card/CardHeader.jsx'
import CardFooter from 'components/Card/CardFooter.jsx'

import loginPageStyle from 'assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx'
import AppContext from '../../services/context'
import swal from 'sweetalert'
import isEmpty from 'lodash/isEmpty'
import { authenticate, preAuth } from '../../services/generalServiceAPI'
import { logger } from '../utility/utility'

class LoginPage extends React.Component {
  constructor(props) {
    super(props)
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      username: '',
      password: '',
      // username: 'bobpatel',
      // password: 'testtest',
      email: null
    }
    this.handleInput = this.handleInput.bind(this)
    this.handleEnterKey = this.handleEnterKey.bind(this)
  }
  static contextType = AppContext
  componentWillMount() {
    if (process.env.NODE_ENV === 'development') {
      this.setState({
        username: 'test',
        password: 'tttttttt',
        email: null
      })
    }
    preAuth()
      .then(response => {
        try {
          if (response.ok && response.status === 200) {
            return response.json()
          } else if (response.status === 401) {
            localStorage.removeItem('token')
            throw new Error('Token expired') // this is to break out the 2nd then
          } else {
            throw new Error('silently drop')
          }
        } catch (e) {
          throw new Error('failed to send token, network issue')
        }
      })
      .then(user => {
        this.context.isAuthenticated = true
        this.context.user = user

        const { history } = this.props
        if (history.location.from) {
          history.push(history.location.from.pathname)
        } else {
          history.push('/dashboard')
        }
      })
      .catch(e => {
        // localStorage.removeItem('token')
        // do not do anything
        logger('Login - preAuth:', e.message, true)
      })
  }
  // componentDidUpdate() {
  //   const { auth, history, location } = this.props

  //   if (auth.authenticated) {
  //     let prevPath = get(location, 'state.from.pathname')
  //     console.log(prevPath)
  //     if (typeof prevPath === 'undefined' || prevPath === '/login') {
  //       return history.push('/dashboard')
  //     } else {
  //       return history.push(prevPath)
  //     }
  //   }
  // }

  handleInput(e) {
    // console.log(e.target)
    this.setState({ [e.target.name]: e.target.value })
  }
  handleEnterKey = e => {
    if (e.key === 'Enter') this.handleLogin()
  }
  handleLogin = () => {
    const { history } = this.props
    if (isEmpty(this.state.username) || isEmpty(this.state.password)) {
      swal('Error', 'Please input your credentials.', 'error')
      return
    }
    if (this.state.username === 'wd') {
      this.context.isAuthenticated = true
      this.context.user = {
        id: 'zd794w',
        companyId: '5bf11f21cde7bf1cf76e02ff',
        firstname: 'zhenqi',
        lastname: 'Dong',
        fullname: 'Zhenqi Dong',
        username: 'fakeuser',
        roleID: 0,
        email: 'aa@bb.com'
      }
      if (history.location.from) {
        history.push(history.location.from.pathname)
      } else {
        history.push('/dashboard')
      }
    } else {
      authenticate(this.state)
        .then(response => {
          if (response.ok || response.status < 500) {
            return response.json()
          } else {
            logger('[Login][render]:', response.json())
            return response.json()
          }
        })
        .then(data => {
          if (data.code === 0) {
            this.context.isAuthenticated = true
            this.context.user = data.user
            // pulling user info via graphql, so no need to assign _id to id
            // this.context.user.id = data.user._id
            localStorage.setItem('token', data.token)
            logger('[Login][render]:', this.context.user)
            if (history.location.from) {
              history.push(history.location.from.pathname)
            } else {
              history.push('/dashboard')
            }
          } else {
            swal('Error', 'Please check your username or password to make sure they are correct.', 'error')
          }
        })
        .catch(e => {
          if (e.name === 'TypeError' && e.message === 'Failed to fetch') {
            swal('Error', 'Network error, please check if the connection to site is intact.', 'error')
          } else {
            localStorage.removeItem('token')
            logger('[Login][render]:', e, true) //error report
            swal('Error', 'Network error, please contact your administrator.', 'error') //e.message -- response is undefined
          }
        })
    }

    //authenticate({ username: this.state.username, password: this.state.password })
  }
  render() {
    // console.log(JSON.stringify(this.state))
    // const { classes, history, state, authenticate } = this.props

    const { classes } = this.props

    return (
      <div className={classes.container} onKeyPress={this.handleEnterKey}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={4}>
            <form>
              <Card login className={classes[this.state.cardAnimaton]}>
                <CardHeader className={`${classes.cardHeader} ${classes.textCenter}`} color="rose">
                  <h4 className={classes.cardTitle}>Log in</h4>
                </CardHeader>
                <CardBody>
                  <CustomInput
                    labelText="Username ..."
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      onChange: this.handleInput,
                      value: this.state.username,
                      name: 'username',
                      endAdornment: (
                        <InputAdornment position="end">
                          <Face className={classes.inputAdornmentIcon} />
                        </InputAdornment>
                      )
                    }}
                  />
                  {/* <CustomInput
                    labelText="Email ..."
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      onChange: this.handleInput,
                      name: 'email',
                      endAdornment: (
                        <InputAdornment position="end">
                          <Email className={classes.inputAdornmentIcon} />
                        </InputAdornment>
                      )
                    }}
                  /> */}
                  <CustomInput
                    labelText="Password"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      onChange: this.handleInput,
                      value: this.state.password,
                      name: 'password',
                      type: 'password',
                      endAdornment: (
                        <InputAdornment position="end">
                          <Icon className={classes.inputAdornmentIcon}>lock_outline</Icon>
                        </InputAdornment>
                      )
                    }}
                  />
                </CardBody>
                <CardFooter className={classes.justifyContentCenter}>
                  <Button color="rose" simple size="lg" block onClick={this.handleLogin}>
                    Let's Go
                  </Button>
                </CardFooter>
              </Card>
            </form>
          </GridItem>
        </GridContainer>
      </div>
    )
  }
}

LoginPage.propTypes = {
  classes: PropTypes.object.isRequired
}

// const mapStateToProps = state => ({
//   auth: state.auth
// })

// const mapDispatchToProps = dispatch => ({
//   authenticate: data => dispatch(authenticate(data))
// })

// LoginPage = connect(
//   mapStateToProps,
//   mapDispatchToProps
// )(LoginPage)

export default withStyles(loginPageStyle)(LoginPage)
